import { Action, createAsyncAction, createReducer } from 'typesafe-actions';
import { produce } from 'immer';
import type { ReduxError } from '@universal/errors';
import { FrontPageType } from '../../../../types/frontPageType';

// Actions
export enum Actions {
  GET_FRONT_PAGE = 'GET_FRONT_PAGE',
  GET_FRONT_PAGE_SUCCESS = 'GET_FRONT_PAGE_SUCCESS',
  GET_FRONT_PAGE_FAIL = 'GET_FRONT_PAGE_FAIL',
  GET_FRONT_PAGE_CANCEL = 'GET_FRONT_PAGE_CANCEL',
}

export interface State {
  data?: FrontPageType;
  meta: { isUpdating: boolean; fetchedAt?: string; isLoggedin?: boolean };
  error?: ReduxError;
}

export const initialState: State = {
  meta: {
    isUpdating: false,
  },
};

export const actions = {
  getFrontPage: createAsyncAction(
    Actions.GET_FRONT_PAGE, // request payload creator
    Actions.GET_FRONT_PAGE_SUCCESS, // success payload creator
    Actions.GET_FRONT_PAGE_FAIL, // failure payload creator
    Actions.GET_FRONT_PAGE_CANCEL, // optional cancel payload creator
  )<[undefined, { token?: string; abTestWeight?: number }], FrontPageType, ReduxError, undefined>(),
};

export const reducers = createReducer<State, Action>(initialState, {})
  .handleAction(actions.getFrontPage.request, (state = initialState, action) =>
    produce(state, (draftState) => {
      draftState.meta = {
        isUpdating: true,
        fetchedAt: draftState.meta.fetchedAt || undefined,
        isLoggedin: !!action.meta.token,
      };
    }),
  )
  .handleAction(actions.getFrontPage.success, (state = initialState, action) =>
    produce(state, (draftState) => {
      draftState.meta = {
        isUpdating: false,
        fetchedAt: new Date().toISOString(),
        isLoggedin: state.meta.isLoggedin,
      };
      draftState.data = action.payload;
      draftState.error = undefined;
    }),
  )
  .handleAction(actions.getFrontPage.failure, (state = initialState, action) =>
    produce(state, (draftState) => {
      // Keep `fetchedAt`/`isLoggedin`, or `useFrontPage` refetches in a loop.
      draftState.meta = { ...state.meta, isUpdating: false };
      draftState.error = action.payload;
    }),
  )
  .handleAction(actions.getFrontPage.cancel, (state = initialState) =>
    produce(state, (draftState) => {
      draftState.meta = { isUpdating: false };
    }),
  );
